import React from 'react';
import PropTypes from 'prop-types';
import MRStops from 'components/form/MRStops';

import VehicleExtras from 'components/form/VehicleExtras';

const MRForm = ({ shipmentKeys, typeOfOrder }) => (
  <div>
    <MRStops shipmentKeys={shipmentKeys} typeOfOrder={typeOfOrder} />
    <VehicleExtras />
  </div>
);

MRForm.propTypes = {
  shipmentKeys: PropTypes.arrayOf(PropTypes.string),
  typeOfOrder: PropTypes.string,
};

MRForm.defaultProps = {
  shipmentKeys: [],
  typeOfOrder: '',
};

export default MRForm;
